import { BackupStatusEnum } from 'src/graphql/schema';
import { OtherBackupStatusEnum } from 'src/shared/constants';

export const backupStatusMap = {
  [BackupStatusEnum.Active]: {
    label: 'Active',
    color: 'text-green-800',
    bgColor: 'bg-green-100',
  },
  [BackupStatusEnum.Draft]: {
    label: 'Draft',
    color: 'text-yellow-600',
    bgColor: 'bg-yellow-50',
  },
  [BackupStatusEnum.Setup]: {
    label: 'Setup',
    color: 'text-slate-800',
    bgColor: 'bg-slate-200',
  },
  [OtherBackupStatusEnum.PendingActivation]: {
    label: 'Pending Activation',
    color: 'text-slate-800',
    bgColor: 'bg-slate-200',
  },
  [BackupStatusEnum.Terminated]: {
    label: 'Terminated',
    color: 'text-rose-800',
    bgColor: 'bg-rose-100',
  },
} as const;
